
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import WaterFlowPreventiveWorkPopup from './WaterFlowPreventiveWorkPopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { useAuthState } from '../../../../../../Helper/Context'
import { useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import moment from 'moment'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { WaterFlowDeleteAPI, WaterFlowExportTableDataAPI, WaterFlowTableDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWorkWaterSupply/WaterFlowSlice'
import { Loading } from '../../../../../../Helper/Loading'
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL'
import { WaterFlowPreventiveWorkExportData } from './WaterFlowPreventiveWorkExportPage'
import { TableNote } from '../../../../../../Components/Note/Note'
import WaterFlowPreventiveWorkExportGrid from './WaterFlowPreventiveWorkExportGrid'


export default function WaterFlowPreventiveWorkPage() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    // console.log(ApiFlag)
    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [WaterQualityPhPopupShow, setWaterQualityPhPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [WaterFlowPreventiveWorkPopupShow, setWaterFlowPreventiveWorkPopupShow] = useState()

    // const [WardName, setWardName] = useState({
    //     DDL: [],
    //     ID: HWard && HWard ? HWard : '0',
    //     Label: WLable && WLable ? WLable : "Select...",
    // })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: RoleID == '16' ? 0 : HWard && HWard ? HWard : '0',
        Label: RoleID == '16' ? "Select..." : WLable && WLable ? WLable : "Select...",
    })

    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [DistributionLineLocationDDL, setDistributionLineLocationDDL] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    const handleEditOnClick = (item) => {
        setWaterFlowPreventiveWorkPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterFlowPreventiveWorkPopupShow(false)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: RoleID == '16' ? 0 : HWard,
            Label: RoleID == '16' ? 'Select...' : WLable,
        })
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
        setDistributionLineLocationDDL({
            ...DistributionLineLocationDDL,
            ID: 0,
            Label: 'Select...',
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
        setDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    // const handleGetPDFUrl = (pdfUrl) => {
    //     // console.log('pdfUrl',pdfUrl)
    //     if (pdfUrl && pdfUrl != '') {
    //         window.open(pdfUrl)
    //         // setPDFUrl(pdfUrl)
    //     }
    //     //  else {
    //     //     toastErrorr("PDF not found")
    //     // }
    // }

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_Distri_WS_LocationID: DistributionLineLocationDDL.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            M_UserID: UserID,
            Flag: 'Grid',
            token: token,
            From: From,
            To: To,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            handleWaterFlowExport: handleWaterFlowExport
        }
        // if (WardName.ID != 0) {
        dispatch(WaterFlowTableDataAPI({ data }))
        // }

    }, [IsPost, From, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.WaterFlowTableData)

    // console.log('tableData', tableData)

    const handleWaterFlowExport = () => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_Distri_WS_LocationID: DistributionLineLocationDDL.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            Flag: 'Report',
            // handleGetPDFUrl: handleGetPDFUrl
        }
        // if (WardName.ID != 0) {
        dispatch(WaterFlowExportTableDataAPI({ data }))
        // }

    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.WaterFlowExportTableData)

    const handleDeleteApi = (item) => {
        const data = {
            T_WS_WaterFlowID: item.t_wS_WaterFlowID,
            T_Distri_WaterFlowID: item.t_Distri_WaterFlowID,
            M_UserID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            handleIsPost: handleIsPost,
            RoleID: RoleID
        }

        dispatch(WaterFlowDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WaterFlowDeleteData)

    const [OpenGridPopUp, setOpenGridPopUp] = useState(false)

    const handleOpenGrid = () => {
        setOpenGridPopUp(!OpenGridPopUp)
    }


    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-5'>
                                <h5 className="mt-2">Water Flow</h5>
                            </div>
                            <div className='col-7 mar_add'>
                                {
                                    DashProjectTypeId == '6' && RoleID != '16' ?
                                        <>
                                            <div className="float-end butt">
                                                {
                                                    isExportLoading ?
                                                        <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                            <i
                                                                className="fa fa-refresh fa-spin"
                                                                style={{ marginRight: "5px" }}
                                                            />Loading</button>
                                                        :
                                                        tableData && tableData.length > 0 &&
                                                        <WaterFlowPreventiveWorkExportData
                                                            ExcelData={ExportTableData}
                                                            FromDate={FromDate}
                                                            ToDate={ToDate}
                                                            name='Water Flow'
                                                            RoleID={RoleID}
                                                        />
                                                }
                                            </div>
                                        </>
                                        :
                                        <div className="float-end butt">
                                            {
                                                isExportLoading ?
                                                    <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                        <i
                                                            className="fa fa-refresh fa-spin"
                                                            style={{ marginRight: "5px" }}
                                                        />Loading</button>
                                                    :
                                                    tableData && tableData.length > 0 &&
                                                    <WaterFlowPreventiveWorkExportData
                                                        ExcelData={ExportTableData}
                                                        FromDate={FromDate}
                                                        ToDate={ToDate}
                                                        name='Water Flow'
                                                        RoleID={RoleID}
                                                    // searchName={searchName}
                                                    />
                                            }
                                        </div>
                                }

                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-2 col-md-4">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={FromDate}
                                                        onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-lg-2 col-md-4">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={ToDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                        min={FromDate}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-lg-2 col-md-4">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>
                                            {
                                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                                    <>
                                                        <div className="col-lg-3 col-md-4">
                                                            <DistributionLineLocationDataDDL
                                                                DistributionLineLocationDDL={DistributionLineLocationDDL}
                                                                setDistributionLineLocationDDL={setDistributionLineLocationDDL}
                                                                WardName={WardName}
                                                            // Flag='ward'
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="col-lg-3 col-md-4">
                                                        <JunctionNameDataDDL
                                                            JunctionNameDDL={JunctionNameDDL}
                                                            setJunctionNameDDL={setJunctionNameDDL}
                                                            WardName={WardName}
                                                        />

                                                    </div>
                                            }
                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger mx-2"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>

                                                {
                                                    tableData && tableData.length > 0 &&
                                                    <>
                                                        {
                                                            (DashProjectTypeId != '6') &&
                                                            <button type="button"
                                                                disabled={isExportLoading}
                                                                className="btn-View btn btn-primary px-3"
                                                                onClick={() => handleOpenGrid()}
                                                            >
                                                                {
                                                                    isExportLoading ?
                                                                        <>
                                                                            <i
                                                                                className="fa fa-refresh fa-spin"
                                                                                style={{ marginRight: "5px" }}
                                                                            />
                                                                        </>
                                                                        : 'View'}
                                                            </button>
                                                        }
                                                    </>
                                                }
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive">
                                            <TableNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Date</th>
                                                        <th>Time</th>
                                                        {
                                                            (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                <th>Location</th>
                                                                :
                                                                <th>Junction</th>
                                                        }
                                                        <th>Pipe Size</th>
                                                        <th>Flow Value</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.length > 0 ? tableData.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td style={{textAlign:'center'}}>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                <td style={{textAlign:'right'}}>{item.readingTime ? item.readingTime : '-'}</td>
                                                                {
                                                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                        <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                                        :
                                                                        <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                                                }
                                                                <td>{item.pipelineDetails ? item.pipelineDetails : '0.00'}</td>
                                                                <td style={{ textAlign: "right" }}>{item.flow ? item.flow : '0'}</td>

                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    {
                                                                        (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                            <>
                                                                                <span >

                                                                                    <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => handleEditOnClick(item)}
                                                                                    >
                                                                                    </i>
                                                                                </span>
                                                                                <span>
                                                                                    <DeletePopup
                                                                                        open={DeletePopupShow}
                                                                                        handleDeleteApi={handleDeleteApi}
                                                                                        item={item}
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WaterFlowPreventiveWorkPopupShow ?
                        <WaterFlowPreventiveWorkPopup
                            open={WaterFlowPreventiveWorkPopupShow}
                            // popupHeading="Water Quality-Chlorine"                        
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashProjectTypeId={DashProjectTypeId}
                            RoleID={RoleID}
                        />
                        : <></>
                }

                {
                    OpenGridPopUp &&
                    <WaterFlowPreventiveWorkExportGrid
                        open={OpenGridPopUp}
                        handleOnCloseClick={handleOpenGrid}
                        ExcelData={ExportTableData}
                        WardName={WardName}
                        JunctionNameDDL={JunctionNameDDL}
                        FromDate={FromDate}
                        ToDate={ToDate}
                    />
                }

            </div>
        </div>



    )
}